import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from './Container';
import { useSEO } from '../hooks/useSEO';


const Pricing = () => {
  const navigate = useNavigate();
  const [billing, setBilling] = useState('monthly');

  const plans = [
    {
      id: 'basic',
      name: 'Basic',
      description: 'Η βάση για την οργάνωση του ιατρείου σας.',
      monthlyPrice: 15,
      max_appointments: 100,
      max_emails: 1000,
      max_users: 2,
      features: [
        'Ηλεκτρονικό Ημερολόγιο',
        'Διαχείριση Ραντεβού',
        'Διαχείριση Βαρδιών (Ποιος δουλεύει & πότε)',
        'Υπενθυμίσεις Email',
        'Υποστήριξη μέσω Email'
      ]
    },
    {
      id: 'professional',
      name: 'Professional',
      description: 'Το πλήρες πακέτο για έναν σύγχρονο κτηνίατρο.',
      monthlyPrice: 29,
      popular: true,
      max_appointments: 300,
      max_emails: 3000,
      max_users: 4,
      features: [
        'Όλα τα features του Basic',
        'Πλήρης Ψηφιακός Φάκελος Ασθενούς ✨',
        'Custom Public Σελίδα Ιατρείου',
        'Λίστα Εργασιών Εργαζομένων (Tasks)',
        'Εσωτερικά Μηνύματα μεταξύ Συναδέλφων',
        'Διαχείριση Αποθήκης & Φαρμάκων',
        'Priority Support'
      ]
    },
    {
      id: 'clinic',
      name: 'Clinic Max',
      description: 'Απεριόριστη ισχύς για μεγάλες ομάδες.',
      monthlyPrice: 59,
      max_appointments: null, 
      max_emails: null,      
      max_users: 5,
      features: [
        'Όλα τα features του Professional',
        'Απεριόριστα Ραντεβού',
        'Απεριόριστα Emails',
        'Σύνδεση με Εξωτερικά Εργαστήρια',
        'Προηγμένη Ασφάλεια Δεδομένων'
      ]
    }
  ];

  useSEO({
    title: 'Τιμολόγηση & Πακέτα - TailClinic',
    description: 'Διαφανείς τιμές χωρίς κρυφές χρεώσεις. Επιλέξτε το πακέτο που ταιριάζει στο κτηνιατρείο σας. Ξεκινήστε σήμερα με 3 μήνες δωρεάν δοκιμή!',
    canonical: 'https://www.tailclinic.gr/pricing',
  });

  
  const getPriceDisplay = (plan) => {
    if (billing === 'monthly') {
      return { 
        main: `€${plan.monthlyPrice}`, 
        sub: '/μήνα',
        note: 'Μηνιαία συνδρομή'
      };
    }
    const yearlyTotal = plan.monthlyPrice * 10;
    const perMonth = (yearlyTotal / 12).toFixed(1);
    return { 
      main: `€${perMonth}`, 
      sub: '/μήνα', 
      note: `€${yearlyTotal}/έτος — 2 Μήνες Δωρεάν! 🎁` 
    };
  };

  return (
    <section style={{ padding: '5rem 0', backgroundColor: '#1A202C', minHeight: '100vh', color: 'white' }}>
      <Container>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h1 style={{ fontSize: '2.8rem', fontWeight: 800, marginBottom: '1rem', letterSpacing: '-0.02em' }}>
            Επιλέξτε το πλάνο που <span style={{ color: '#10B981' }}>σας ταιριάζει</span>
          </h1>
          <p style={{ color: '#9CA3AF', fontSize: '1.1rem' }}>
            Ξεκινήστε με 3 μήνες δωρεάν. Ακυρώστε οποιαδήποτε στιγμή.
          </p>
          
          {/* Billing Toggle */}
          <div style={{ 
            display: 'inline-flex', 
            backgroundColor: '#111827', 
            padding: '0.4rem', 
            borderRadius: '9999px', 
            border: '1px solid #374151', 
            marginTop: '2.5rem',
            position: 'relative'
          }}>
            <button 
              onClick={() => setBilling('monthly')} 
              style={{ 
                padding: '0.6rem 1.5rem', 
                borderRadius: '9999px', 
                border: 'none', 
                cursor: 'pointer', 
                backgroundColor: billing === 'monthly' ? '#10B981' : 'transparent', 
                color: billing === 'monthly' ? '#111827' : '#9CA3AF', 
                fontWeight: 700,
                transition: 'all 0.2s'
              }}
            >
              Μηνιαία
            </button>
            <button 
              onClick={() => setBilling('yearly')} 
              style={{ 
                padding: '0.6rem 1.5rem', 
                borderRadius: '9999px', 
                border: 'none', 
                cursor: 'pointer', 
                backgroundColor: billing === 'yearly' ? '#10B981' : 'transparent', 
                color: billing === 'yearly' ? '#111827' : '#9CA3AF', 
                fontWeight: 700,
                transition: 'all 0.2s'
              }}
            >
              Ετήσια (2 Μήνες Δώρο)
            </button>
          </div>
        </div>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
          gap: '2.5rem' 
        }}>
          {plans.map((plan) => {
            const price = getPriceDisplay(plan);
            return (
              <div 
                key={plan.id} 
                style={{ 
                  backgroundColor: '#1F2937', 
                  padding: '2.5rem', 
                  borderRadius: '1.5rem', 
                  border: plan.popular ? '2px solid #10B981' : '1px solid #374151', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  position: 'relative',
                  boxShadow: plan.popular ? '0 10px 30px -10px rgba(16,185,129,0.3)' : 'none'
                }}
              >
                {plan.popular && (
                  <div style={{ 
                    position: 'absolute', 
                    top: '-14px', 
                    left: '50%', 
                    transform: 'translateX(-50%)', 
                    backgroundColor: '#10B981', 
                    color: '#111827', 
                    padding: '0.3rem 1.2rem', 
                    borderRadius: '9999px', 
                    fontSize: '0.75rem', 
                    fontWeight: 900,
                    textTransform: 'uppercase'
                  }}>
                    Προτεινόμενο
                  </div>
                )}
                
                <h3 style={{ fontSize: '1.6rem', fontWeight: 700, marginBottom: '0.5rem' }}>{plan.name}</h3>
                <p style={{ color: '#9CA3AF', fontSize: '0.9rem', marginBottom: '1.5rem', minHeight: '2.5rem' }}>{plan.description}</p>
                
                <div style={{ marginBottom: '2rem' }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.3rem' }}>
                    <span style={{ fontSize: '3.2rem', fontWeight: 800 }}>{price.main}</span>
                    <span style={{ color: '#9CA3AF', fontSize: '1.1rem' }}>{price.sub}</span>
                  </div>
                  <div style={{ 
                    fontSize: '0.85rem', 
                    color: billing === 'yearly' ? '#10B981' : '#6B7280', 
                    fontWeight: 600,
                    marginTop: '0.2rem'
                  }}>
                    {price.note}
                  </div>
                </div>

                {/* Limits Box */}
                <div style={{ 
                  backgroundColor: 'rgba(0,0,0,0.25)', 
                  padding: '1.25rem', 
                  borderRadius: '1rem', 
                  marginBottom: '2rem', 
                  fontSize: '0.95rem',
                  border: '1px solid rgba(255,255,255,0.05)'
                }}>
                  <div style={{ marginBottom: '0.6rem', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                    <span>📅</span> {plan.max_appointments ? `${plan.max_appointments} ραντεβού/μήνα` : 'Απεριόριστα ραντεβού'}
                  </div>
                  <div style={{ marginBottom: '0.6rem', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                    <span>📧</span> {plan.max_emails ? `${plan.max_emails.toLocaleString()} emails/μήνα` : 'Απεριόριστα emails'}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                    <span>👥</span> Έως {plan.max_users} χρήστες
                  </div>
                </div>

                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 2.5rem 0', flex: 1 }}>
                  {plan.features.map((f, i) => (
                    <li key={i} style={{ 
                      marginBottom: '0.8rem', 
                      display: 'flex', 
                      alignItems: 'flex-start', 
                      gap: '0.7rem', 
                      color: '#D1D5DB',
                      fontSize: '0.95rem'
                    }}>
                      <span style={{ color: '#10B981', fontWeight: 'bold' }}>✓</span> {f}
                    </li>
                  ))}
                </ul>

                <button 
                  onClick={() => navigate('/signup')} 
                  style={{ 
                    width: '100%', 
                    padding: '1.1rem', 
                    borderRadius: '1rem', 
                    border: 'none', 
                    backgroundColor: plan.popular ? '#10B981' : '#374151', 
                    color: plan.popular ? '#111827' : 'white', 
                    fontWeight: 800, 
                    fontSize: '1rem',
                    cursor: 'pointer',
                    transition: 'transform 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  Ξεκινήστε Δωρεάν
                </button>
              </div>
            );
          })}
        </div>
        
        <p style={{ textAlign: 'center', marginTop: '4rem', color: '#6B7280', fontSize: '0.85rem' }}>
          * Οι τιμές δεν περιλαμβάνουν ΦΠΑ. Η προσφορά των 2 μηνών δώρο ισχύει για ετήσια προπληρωμή.
        </p>
      </Container>
    </section>
  );
};

export default Pricing;